import { render, staticRenderFns } from "./PeriodSelector.vue?vue&type=template&id=f385e71a&scoped=true&"
import script from "./PeriodSelector.vue?vue&type=script&lang=ts&"
export * from "./PeriodSelector.vue?vue&type=script&lang=ts&"
import style0 from "./PeriodSelector.vue?vue&type=style&index=0&id=f385e71a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f385e71a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFadeTransition } from 'vuetify/lib/components/transitions';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VFadeTransition,VRow,VSpacer})
